// extracted by mini-css-extract-plugin
module.exports = {"root":"Question_root__2LNxd","question":"Question_question__3dO3u","description":"Question_description__2Izr5"};